module.exports = __webpack_public_path__ + "img/ESG_03.1c1ecca3.png";